import React, { useState, useEffect } from 'react';

/**
 * Renders children only after client-side hydration is complete.
 * Use for components that use browser portals, localStorage, or other browser
 * APIs in their render path — prevents React hydration structural mismatches.
 *
 * @param {React.ReactNode} children
 * @param {React.ReactNode} [fallback=null] - What to render during SSR/hydration
 */
const ClientOnly = ({ children, fallback = null }) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => { setHasMounted(true); }, []);
  if (!hasMounted) return fallback;
  return children;
};

export default ClientOnly;
